import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { useAuth } from '@/hooks/useAuth';
import { useCurrentAppUser } from '@/hooks/useCurrentAppUser';
import { usePushNotifications } from '@/hooks/usePushNotifications';

export default function MobileProfile() {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const { data: appUser } = useCurrentAppUser();
  const { isSubscribed, isLoading, subscribe, unsubscribe } = usePushNotifications();
  const [changingPush, setChangingPush] = useState(false);

  const name = useMemo(() => {
    return appUser?.display_name || user?.user_metadata?.display_name || user?.email || 'Usuario';
  }, [appUser, user]);

  const handleTogglePush = async (nextChecked: boolean) => {
    setChangingPush(true);
    try {
      if (nextChecked) {
        await subscribe();
      } else {
        await unsubscribe();
      }
    } finally {
      setChangingPush(false);
    }
  };

  return (
    <div className="space-y-3 p-3">
      <div className="rounded-lg border bg-card p-3">
        <h2 className="text-sm font-semibold">Perfil</h2>
        <p className="mt-1 text-sm">{name}</p>
        <p className="text-xs text-muted-foreground">{user?.email}</p>
      </div>

      <div className="rounded-lg border bg-card p-3">
        <div className="flex items-center justify-between gap-3">
          <div>
            <p className="text-sm font-medium">Notificacoes push</p>
            <p className="text-xs text-muted-foreground">Receber alertas no app instalado</p>
          </div>
          <Switch
            checked={isSubscribed}
            disabled={isLoading || changingPush}
            onCheckedChange={handleTogglePush}
            aria-label="Ativar notificacoes push"
          />
        </div>
      </div>

      <div className="grid gap-2">
        <Button
          variant="outline"
          onClick={() => {
            localStorage.setItem('divus-view-preference', 'mobile');
            navigate('/m/', { replace: true });
          }}
        >
          Fixar visual mobile
        </Button>

        <Button variant="destructive" onClick={() => signOut()}>
          Sair
        </Button>
      </div>
    </div>
  );
}
